import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
// 映射文件

import stateTest from './state/test'


import getters from './getters'
import mutations from './mutations'
import actions from './actions'

var state = null;
console.log(process.env.VUE_APP_BASE_PATH);
console.log(process.env.VUE_APP_FILE_PATH);
//  默认使用test包
state = stateTest;

const store = new Vuex.Store({
    state,getters,mutations,actions
})

export default store

// vuex全局储存数据